import { Fragment } from 'react';
import {
  Grid,
  Box,
  Typography,
  useTheme,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TableHead,
  TableBody,
  Table,
  TableCell,
} from '@mui/material';

import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import FallingCheckbox from './components/FallingCheckbox';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const radioId = [
  'no5_1',
  'no5_2',
  'no5_3',
  'no5_4',
  'no5_5',
  'no5_6',
  'no5_7',
  'no5_8',
  'no5_9',
  'no5_10',
  'no5_11',
];

const contentLabel = [
  {
    id: 1,
    ko: '① 이식 또는 VAD를 시행할 수 없는 경우',
    desc: ['inhibition1'],
  },
  {
    id: 2,
    ko: '② ROSC 없이 60분 이상의 CPR을 진행한 경우',
    desc: ['inhibition2'],
  },
  {
    id: 3,
    ko: '③ 심폐소생술을 거부한 경우',
    desc: ['inhibition3'],
  },
  {
    id: 4,
    ko: '④ Unwitnessed Cardiac arrest (ETCO2 10mmHg 이하)',
    desc: ['inhibition4'],
  },
  {
    id: 5,
    ko: '⑤ 호흡부전환자에서 FiO2>90% 혹은 Pplat>30cmH2O의 인공호흡기를 7일 이상 유지한 경우',
    desc: ['inhibition5'],
  },
  {
    id: 6,
    ko: '⑥ 최근 발생한 뇌출혈 혹은 지혈이 불가능한 지속적 출혈',
    desc: ['inhibition6'],
  },
  {
    id: 7,
    ko: '⑦ 48시간 이상 진행된 다발성 장기부전',
    desc: ['inhibition7'],
  },
  {
    id: 8,
    ko: '⑧ 진행성 혈액암, 골수이식 실패, 무과립구증, 절대호중구수 (ANC)<400 등 심한 면역기능저하',
    desc: ['inhibition8'],
  },
  {
    id: 9,
    ko: '⑨ 비가역적인 중추신경계 손상',
    desc: ['inhibition9'],
  },
  {
    id: 10,
    ko: '⑩ 말기암, 폐, 간, 신장의 만성 중증 장기부전',
    desc: ['inhibition10'],
  },
  {
    id: 11,
    ko: '⑪ 대동맥판 폐쇄부전이나 급성대동맥박리 환자',
    desc: ['inhibition11'],
  },
];

const Inhibition = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
  };

  return (
    <Fragment>
      <SectionTitle title="4. 금기증 (필수 기재)" />
      <RowContainer xs={12}>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <FallingCheckbox
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="SAFETY.PATIENT.RISK.FACTORS"
            values={[1, 2]}
            defaultValue={getValues('inhibition_check')}
            onChange={v => setValue('inhibition_check', v)}
          />
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <div style={{ display: 'table-row' }}>
            <Table>
              <TableHead>
                <TableRow sx={{ display: 'block', marginTop: '-30px' }}>
                  <TableCell align="right" sx={{ display: 'flex' }}>
                    <Typography
                      sx={{
                        marginRight: '170px',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                    >
                      예
                    </Typography>
                    <Typography
                      sx={{
                        marginRight: '310px',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                    >
                      아니오
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contentLabel.map(
                  (content: { id: number; ko: string; desc: string[] }, i) => {
                    return (
                      <TableRow sx={{ display: 'block' }}>
                        <StyledTableCellTwo
                          align="left"
                          sx={{
                            paddingLeft: '10px',
                            paddingTop: '16px',
                            paddingBottom: '16px',
                            width: '100vw',
                            whiteSpace: 'nowrap',
                            fontSize: '12px',
                            fontWeight: 400,
                          }}
                        >
                          {content.ko}
                        </StyledTableCellTwo>
                        <StyledTableCellTwo
                          align="center"
                          sx={{
                            padding: '16px',
                            width: '70px',
                            whiteSpace: 'nowrap',
                          }}
                        ></StyledTableCellTwo>
                        <StyledTableCellWithoutLeftRightTwo></StyledTableCellWithoutLeftRightTwo>
                        <StyledTableCellWithoutLeftTwo sx={{ width: '180px' }}>
                          <RadioGroup
                            name={content.desc[0]}
                            defaultValue={Number(getValues(content.desc[0]))}
                          >
                            {content.desc.map((key, i) => (
                              <TableRow
                                sx={{
                                  height: '44px',
                                  lineHeight: '44px',
                                  textAlign: 'center',
                                }}
                              >
                                <Box
                                  sx={{
                                    width: '700px',
                                  }}
                                >
                                  <FormControlLabel
                                    sx={{ paddingRight: '300px' }}
                                    label=""
                                    control={
                                      <Radio
                                        disabled={disabled}
                                        name={key}
                                        value={i}
                                        onChange={handleChange}
                                      />
                                    }
                                  />
                                  <FormControlLabel
                                    label=""
                                    control={
                                      <Radio
                                        disabled={disabled}
                                        name={key}
                                        value={i + 1}
                                        onChange={handleChange}
                                      />
                                    }
                                  />
                                </Box>
                              </TableRow>
                            ))}
                          </RadioGroup>
                        </StyledTableCellWithoutLeftTwo>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </div>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Inhibition;
